import { memo } from 'react';
import "./MissMFC.linaria.module.css!=!./MissMFC?./MissMFC.linaria.module.css?css=H4sIAAAAAAAAA1XK0QpAMBQA0Hf/Qo0S8zFruOzq2mSXYfl3pTx4PHUyzbMySpjSTduV/RQ14WhTZJi97MAyrM2dvKfzqrKFyNu/4uAspwFwNCxbR/33a68EHwF3ij36hfQpB4KjuZMH9szoz4EAAAA="
interface MissMFCBadgeProps {
  missMFCRank?: number;
  compact?: boolean;
}
const missMfcStyles = "atm_h_1h6ojuz atm_cs_8n312b atm_9s_1txwivl";
const MissMFCBadge = memo((props: MissMFCBadgeProps) => {
  const {
    missMFCRank = '',
    compact
  } = props;
  return <div className={missMfcStyles}>
            {(compact ? '' : 'MFC ') + '#' + missMFCRank}
        </div>;
});
export default MissMFCBadge;
export { MissMFCBadge };